(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/coupon/outcome-percent.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/coupon/outcome-percent.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.views = svs.matchen.views || {};

  svs.matchen.views.OutcomePercent = svs.matchen.views.Outcome.extend({
    className:
      'view-outcome-percent outcome outcome-percent btn-bet btn-bet-default btn-bet-300 btn-bet-align-right btn-bet-text-align-left btn-bet-fixed-width',

    template: function(data) {
      return svs.matchen.templates.outcome_percent(data);
    },

    templateContext: function() {
      return {
        maxPercent: this.options.maxPercent
      };
    }
  });
})(Backbone, _, svs);


 })(window);